<template>
  <!-- 监控组件 -->
  <el-dialog title="打印舱标" :visible="DayinDialog" :before-close="closeDialog" :close-on-click-modal="false" center width='30%'>
    <el-form ref="ZBform" :model="dayinForm" class="demo-form-inline jiaoyan" label-width="100px" size="mini" :rules="rules">
      <div class="QDtiem">
        <div>
          <el-form-item label="船运编号:" prop="OrderNumber">
            <el-input v-model="dayinForm.OrderNumber" style="width:250px;" :disabled="true" size="mini" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="航次号:" prop="VoyageNo">
            <el-input v-model="dayinForm.VoyageNo" style="width:250px;" :disabled="true" size="mini" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="船舶名称:" prop="ShipName">
            <el-input v-model="dayinForm.ShipName" style="width:250px;" :disabled="true" size="mini" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="货物类型:" prop="GoodType">
            <el-select v-model="dayinForm.GoodType" style="width:250px;" size="mini" value-key="productId" placeholder="请选择">
              <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="船舱号:" prop="CargoHold">
            <el-input v-model="dayinForm.CargoHold" v-number-input.float="0" style="width:250px;" size="mini" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="排位号:" prop="CargoAreaS">
            <el-input v-model="dayinForm.CargoAreaS" v-number-input.float="0" style="width:115px;" size="mini" placeholder=""></el-input> ～
            <el-input v-model="dayinForm.CargoAreaE" v-number-input.float="0" style="width:111px;" size="mini" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="层位号:" prop="CargoFloorS">
            <el-select v-model="dayinForm.CargoFloorS" style="width:115px;" placeholder="请选择">
              <el-option v-for="item in CengOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> ～
            <el-select v-model="dayinForm.CargoFloorE" style="width:111px;" placeholder="请选择">
              <el-option v-for="item in CengOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div>
      <div id="printMe" ref="print1">
        <!-- 打印 -->
        <div v-for="(item, index) in list" :key="index" class="div">
          <div class="divInner" style="page-break-after:always;">
            <div class="VoyageNoShipName"><span style="margin-right:30px;">{{item.VoyageNo}}</span> <span>{{item.ShipName}}</span></div>
            <div class="OrderNumber">{{item.OrderNumber}}</div>
            <div class="CargoHAF"><span>{{item.CargoHold}}舱</span><span style="margin:0 30px;">{{item.CargoArea}}排</span><span>{{item.CargoFloor}}</span></div>
            <qriously v-show="getFlag" :id="'qriously' + index" :value="item.qrCode" :size="160" />
            <img :src="item.src" alt="" v-show="!getFlag" />
          </div>

        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="yulan">预览</el-button>
      <el-button type="primary" @click="dayin">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { zidian } from '@/api/wms-access'
import { dateFormat1 } from '@/utils/util'
export default {
  name: 'dayinDialog',
  props: {
    DayinDialog: {
      type: Boolean,
      default: false
    },
    OrderNumber: {
      type: String
    },
    VoyageNo: {
      type: String
    },
    ShipName: {
      type: String
    },
    id: {
      type: Number
    }
  },
  data () {
    return {
      productTypes: [],
      dayinForm: {
        OrderNumber: '',
        VoyageNo: '',
        ShipName: '',
        GoodType: '',
        CargoHold: '',
        CargoAreaS: '',
        CargoAreaE: '',
        CargoFloorS: '',
        CargoFloorE: ''
      },
      CengOptions: [
        {
          id: 1,
          name: '底层'
        },
        {
          id: 2,
          name: '中层'
        },
        {
          id: 3,
          name: '上层'
        }
      ],
      list: [],
      lists: [],
      getFlag: true,
      rules: {
        OrderNumber: [
          { required: true, message: '请选择货物类型', trigger: 'change' }
        ],
        VoyageNo: [
          { required: true, message: '请输入船舱号', trigger: 'blur' }
        ],
        ShipName: [
          { required: true, message: '请选择接单时间', trigger: 'blur' }
        ],
        GoodType: [
          { required: true, message: '请选择货物类型', trigger: 'change' }
        ],
        CargoHold: [
          { required: true, message: '请输入船舱号', trigger: 'blur' }
        ],
        CargoAreaS: [
          { required: true, message: '请输入排位号', trigger: 'blur' }
        ],
        CargoFloorS: [
          { required: true, message: '请选择层位号', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.dayinForm.OrderNumber = this.OrderNumber
    this.dayinForm.VoyageNo = this.VoyageNo
    this.dayinForm.ShipName = this.ShipName
    // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.zidian()
  },
  methods: {
    closeDialog () {
      this.$emit('update:DayinDialog', false)
    },
    dataHandle () {
      if (this.dayinForm.CargoAreaE == '') {
        this.dayinForm.CargoAreaE = this.dayinForm.CargoAreaS
      }
      if (this.dayinForm.CargoFloorE == '') {
        this.dayinForm.CargoFloorE = this.dayinForm.CargoFloorS
      }
      this.list = []
      let maxPai = Math.max(this.dayinForm.CargoAreaS, this.dayinForm.CargoAreaE)
      let minPai = Math.min(this.dayinForm.CargoAreaS, this.dayinForm.CargoAreaE)

      let maxCeng = Math.max(this.dayinForm.CargoFloorS, this.dayinForm.CargoFloorE)
      let minCeng = Math.min(this.dayinForm.CargoFloorS, this.dayinForm.CargoFloorE)
      console.log(maxCeng, minCeng)
      for (let i = minPai; i <= maxPai; i++) {
        for (let j = minCeng; j <= maxCeng; j++) {
          let oo = {}
          let obj = this.utf16to8(JSON.stringify({
            OrderNumber: this.dayinForm.OrderNumber,
            VoyageNo: this.dayinForm.VoyageNo,
            ShipName: this.dayinForm.ShipName,
            GoodType: this.dayinForm.GoodType,
            // GoodTypeName: this.dayinForm.ShipName,
            CargoHold: this.dayinForm.CargoHold,
            CargoArea: i,
            CargoFloor: j == 1 ? '底层' : j == 2 ? '中层' : '上层',
            // OperatorName: this.dayinForm.OperatorName,
            Date: dateFormat1(new Date(), 'YYYY-MM-ss h-m-s'),
            shipDateId: this.id
          }))
          oo.VoyageNo = this.dayinForm.VoyageNo
          oo.ShipName = this.dayinForm.ShipName
          oo.OrderNumber = this.dayinForm.OrderNumber
          oo.CargoHold = this.dayinForm.CargoHold
          oo.CargoArea = i
          oo.CargoFloor = j == 1 ? '底层' : j == 2 ? '中层' : '上层'
          oo.qrCode = obj
          this.list.push(oo)
        }
      }
    },
    yulan () {
      this.$refs.ZBform.validate(valid => {
        if (valid) {
          this.dataHandle()
          this.$emit('update:DayinDialog', false)
          this.$router.push({
            name: 'dayinBiaoqian',
            query: { list: JSON.stringify(this.list) }
          })
        }
      })
    },
    dayin () {
      this.$refs.ZBform.validate(valid => {
        if (valid) {
          this.dataHandle()
          setTimeout(() => {
            this.printContext('one')
          }, 500)
        }
      })
      // this.list = JSON.parse(JSON.stringify(this.lists))
    },
    zidian () {
      zidian({
        groupNo: 'product_type'
      })
        .then((res) => {
          this.productTypes = res
        })
        .catch((err) => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 二维码支持中文
    utf16to8 (str) {
      var out, i, len, c
      out = ''
      len = str.length
      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i)
        if (c >= 0x0001 && c <= 0x007f) {
          out += str.charAt(i)
        } else if (c > 0x07ff) {
          out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f))
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
        } else {
          out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
        }
      }
      console.log(out)
      return out
    },
    printContext (name) {
      this.getFlag = false
      this.list.forEach((item, index) => {
        item.qrCode = this.utf16to8(item.qrCode)
        item.src = ''
        let canvas = document.querySelector(
          '#qriously' + index + ' ' + 'canvas'
        )
        item.src = canvas.toDataURL('image/png')
      })
      console.log(this.list)
      if (name == 'one') {
        setTimeout(() => {
          this.$print(this.$refs.print1)
        }, 500)
      }
    }

  }
}
</script>

<style scoped lang='less'>
#printMe {
  height: 0px;
  overflow: hidden;
}
.div {
  width: 480px;
  height: 480px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 40px;
  .divInner {
    width: 400px;
    height: 400px;
    border: 2px solid #ccc;
    border-radius: 50%;
    box-sizing: border-box;
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .VoyageNoShipName {
      font-size: 27px;
      font-weight: 600;
      margin-bottom: 5px;
      margin-top: 15px;
    }
    .OrderNumber {
      margin-bottom: 5px;
      font-size: 18px;
    }
    .CargoHAF {
      margin-bottom: 15px;
      font-size: 26px;
    }
  }
}
</style>
